__turbopack_context__.v({
  "backButton": "ModalHeader-module-scss-module__PWo2UW__backButton",
  "backIcon": "ModalHeader-module-scss-module__PWo2UW__backIcon",
  "closeButton": "ModalHeader-module-scss-module__PWo2UW__closeButton",
  "closeIcon": "ModalHeader-module-scss-module__PWo2UW__closeIcon",
  "controlsRow": "ModalHeader-module-scss-module__PWo2UW__controlsRow",
  "modalHeader": "ModalHeader-module-scss-module__PWo2UW__modalHeader",
  "spacer": "ModalHeader-module-scss-module__PWo2UW__spacer",
  "subtitle": "ModalHeader-module-scss-module__PWo2UW__subtitle",
  "title": "ModalHeader-module-scss-module__PWo2UW__title",
  "titleContainer": "ModalHeader-module-scss-module__PWo2UW__titleContainer",
  "titleContainerNoBottom": "ModalHeader-module-scss-module__PWo2UW__titleContainerNoBottom",
});
